/**
 * metadata tags constants
 */
export const MetadataTagsConstants = {
  LISTENING_LABEL: 'Listening'
}
export const scoreFormatTypes = {
    percent: "percentage"
}
export const TestSubTypeConstants = {
  "competency": "competency",
  "unit-progress": "unit-progress",
  "practice": "practice",
  "course-specific":"course-specific"
}